'use client';

import EditorCta, { type EditorSeed } from '@/components/seo/EditorCta';

/** Shared, non-pushy closer for every public tool page. */
export const TOOL_GENERIC_LEAD =
  'Preview only — open the 3D builder for full placement, treatment, and analysis.';

interface Props {
  /** One concise, tool-specific result sentence. */
  result: string;
  ctaLabel?: string;
  /** The room to open the editor on, from this tool's own live dimensions —
   *  a visitor who has already dialed in a room should not land on a blank
   *  default one. Omit for tools with no room geometry of their own. */
  seed?: EditorSeed;
}

/** The closing panel inside a calculator widget: its live result, then the editor.
 *  This is the ONE place a tool's "try the real thing" moment lives — directly
 *  under the result, never after the FAQ (S5, AGENTS.md §0 cohesion audit). */
export default function ToolLeadIn({ result, ctaLabel = 'Try the full product', seed }: Props) {
  return (
    <EditorCta
      label={ctaLabel}
      text={result}
      note={TOOL_GENERIC_LEAD}
      location="tool_lead_in"
      testId="tool-lead-in"
      seed={seed}
    />
  );
}
